import address from "./address";

const basePath = address.basePath + "cimosform/";
var bpmPath = address.basePath + "cimosform/bpm/";// 
const cimosBpmPath = address.basePath + "cimosbpm/";
// const cimosFlowPath = address.basePath + "cimosflow/";

export default {
    login: address.basePath + 'index/oauth/webLogin',   //用户名账号密码登陆
    token: address.basePath + 'uaa/oauth/token',//获取用户token
    currUser: address.basePath + 'third/currUser',//获取用户租户信息
    refreshToken: address.basePath + 'third/refreshToken',//刷新当前token2小时失效

    uploadFilesToPath: address.uploadFile + "file/cimosFiles/uploadFilesToPath",//上传文件的地址
    viewFile: address.uploadFile + "file/cimosFiles/pdf/view",//Word/Excel/PPT等文件预览
    viewImageFile: address.viewImage,   //直接访问图片和txt文件

    formTypes: basePath + "formTypes",//获取表单分类 
    formInfo: basePath + "form/formInfo",//post :保存表单 | get /{:id} :获取表单详情
    editFormInfo: basePath + "form/editFormInfo",//post :编辑表单


    data: basePath + "data",//get:{formId} 获取表单数据 ||post :保存数据 || post:/{formId}/{dataId} 根据数据ID获取数据详情
    editData: basePath + "editData",//post :编辑数据

    startBpm: bpmPath + "startBpm",//发起流程
    reStartBpm: bpmPath + "reStartBpm",//重新发起流程表单
    getTaskByInstanceId: cimosBpmPath + "getTaskByInstanceId",//查询流程办理记录


    formInfoOpen:basePath + "form/web/formInfo",//post :获取公开表单信息
    dataOpen:basePath + "web/data",//post :公开保存数据

    getProcessHistory:basePath + "bpm/getProcessHistory",//获取

    // https://api.otgov.com/cimosflow/getProcessHistory
};